import { useFilterHolidayContext } from "./filter-holiday.context";

export function FilterHoliday() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterHolidayContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}
